"use strict";


/**
 * Start-End Date/DateTime filter component optimized for model management event handling
 */
angular.module("core")
.component("startEndDateTimeFilter", {
    templateUrl: require("./start-end-date-time-filter.component.html"),
    controller: StartEndDateTimeFilterController,
    bindings: {
        filterField: "@",
        labelName: "<?",
        dateOnly: "<?",
        filterWithTime: "<?"
    }
});

function StartEndDateTimeFilterController($scope, $state, $stateParams, $controller, $timeout) {
    angular.extend(this, $controller("abstractStartEndDateTimeController", {
        $scope: $scope,
        dateOnly: !!this.dateOnly
    }));
    var _this = this;
    var startFilterField = this.filterField + '_start';
    var endFilterField = this.filterField + '_end';
    var filters = {};
    filters[startFilterField] = $stateParams[startFilterField]
    filters[endFilterField] = $stateParams[endFilterField]

    var initialFilter = angular.extend({}, filters);

    this.refreshStartDateFilter = function(reference) {
        if (reference) {
            this.updateEndDateMin(reference);
        }
        else {
            $scope.endDateOptions.minDate = false;
        }

        if (this.dateOnly && reference) {
            this.startDateModel = this.getBeginningOfTheDay(reference);
        }

        this.formatDateFiltersAndEmit();
    };

    this.refreshEndDateFilter = function(reference) {
        if (reference) {
            this.updateStartDateMax(reference);
        }
        else {
            $scope.startDateOptions.maxDate = false;
        }

        if (this.dateOnly && reference) {
            this.endDateModel = this.getEndOfTheDay(reference);
        }

        this.formatDateFiltersAndEmit();
    };

    this.formatDateFiltersAndEmit = function() {
        if (typeof this.startDateModel !== "object") {
            this.startDateModel = null;
        }

        var startDateStr;
        if (this.startDateModel) {
            if (this.dateOnly && !this.filterWithTime) {
                startDateStr = this.startDateModel.format("YYYY-MM-DD");
            } else {
                startDateStr = this.startDateModel.toISOString();
            }
        }

        if (typeof this.endDateModel !== "object") {
            this.endDateModel = null;
        }

        var endDateStr;
        if (this.endDateModel) {
            if (this.dateOnly && !this.filterWithTime) {
                endDateStr = this.endDateModel.format("YYYY-MM-DD");
            } else {
                endDateStr = this.endDateModel.toISOString();
            }
        }

        filters[startFilterField] = startDateStr;
        filters[endFilterField] = endDateStr;

        var filterValuesHasChanged = !angular.equals(filters, initialFilter);
        if (filterValuesHasChanged) {
            $scope.$emit("dateFilterUpdated", filters);
            initialFilter = angular.copy(filters);
        }
    };

    if ($stateParams[startFilterField]) {
        this.startDateModel = $stateParams[startFilterField];
    }

    if ($stateParams[endFilterField]) {
        this.endDateModel = $stateParams[endFilterField];
    }

    $scope.$on("setDateFilter", function(event, dateFilterField, dateFilterValues) {
        var startSetFilterField = dateFilterField + '_start';
        var endSetFilterField = dateFilterField + '_end';

        $scope.startDateOptions.maxDate = false;
        $scope.endDateOptions.minDate = false;

        $timeout(function() {
            if (dateFilterValues[endSetFilterField]) {
                _this.endDateModel = dateFilterValues[endSetFilterField];
                $scope.endDateOptions.viewDate = _this.endDateModel.format("YYYY-MM-DD");
            }

            if (dateFilterValues[startSetFilterField]) {
                _this.startDateModel = dateFilterValues[startSetFilterField];
                $scope.startDateOptions.viewDate = _this.startDateModel.format("YYYY-MM-DD");
            }

            if (_this.endDateModel && typeof _this.endDateModel === "object" && _this.endDateModel.isValid()) {
                $scope.startDateOptions.maxDate = moment(_this.endDateModel).endOf('day');
            }

            if (_this.startDateModel && typeof _this.startDateModel === "object" && _this.startDateModel.isValid()) {
                $scope.endDateOptions.minDate = moment(_this.startDateModel).startOf('day');
            }
            _this.formatDateFiltersAndEmit();
        });
    });
}



//////////////////
// WEBPACK FOOTER
// ./core/start-end-date/start-end-date-time-filter.component.js
// module id = 537
// module chunks = 0